/**
 * Listens to checkout terminal select field, enables shipping details, fills it out
 * and triggers checkout update.
 */
 const maksimerTerminalSelection = ( select ) => {
    const checkbox = document.querySelector('#ship-to-different-address-checkbox');

    if (!checkbox) {
        console.error('No ship to different address checkbox present!');
        select.style.display = 'none';
        return;
    }

    const address = document.querySelector('#shipping_address_1');
    const postcode = document.querySelector('#shipping_postcode');
    const city = document.querySelector('#shipping_city');
    const shippingContainer = document.querySelector('.shipping_address');
    const shippingFields = shippingContainer.querySelectorAll('input');
    const activeShippingMethod = document.querySelector('#shipping_method input:checked') ? document.querySelector('#shipping_method input:checked').value : '';
    const activeShippingMethodLabel = document.querySelector('#shipping_method input:checked') ? document.querySelector('#shipping_method input:checked').parentNode.querySelector('label') : '';
    const name = document.querySelector('#shipping_first_name');
    const surname = document.querySelector('#shipping_last_name');
    const company = document.querySelector('#shipping_company');
    const billingName = document.querySelector('#billing_first_name');
    const billingSurname = document.querySelector('#billing_last_name');
    const billingCompany = document.querySelector('#billing_company');
    const shippingShowChosenVal = document.querySelector('.maksimer-terminal-choosen-option');
    const displayShippingTerminal = document.querySelector('.leveringsadresse-terminal');
    const displayShippingAddress = document.querySelector('.leveringsadresse-address');
    const displayShippingPostcode = document.querySelector('.leveringsadresse-postcode');
    const displayShippingLocal = document.querySelector('.leveringsadresse-local');
    const displayShippingCity = document.querySelector('.leveringsadresse-city');
    const checkboxWrap = document.querySelector('#ship-to-different-address');
    const terminalWrap = document.querySelector('.maksimer-terminal-list');

    if (!checkbox.checked) {
        checkbox.checked = true;
        if (shippingContainer) {
            shippingContainer.style.display = 'block';
        }
    }

    if (activeShippingMethod.includes('local_pickup')) {
        select.value = '0';
        terminalWrap.classList.add('--disabled');
    } else {
        terminalWrap.classList.remove('--disabled');
    }

    if (!select.value || select.value === '0' || activeShippingMethod.includes('local_pickup')) {
        checkbox.checked = false;

        if (shippingContainer) {
            shippingContainer.style.display = 'none';
            checkboxWrap.style.display = 'inline-block';
            shippingShowChosenVal.style.display = 'none';
        }

        if (shippingFields) {
            shippingFields.forEach((shippingField) => {
                shippingField.removeAttribute('readonly');
                shippingField.classList.remove('--readonly');
            });
        }

        if (displayShippingTerminal) {
            displayShippingTerminal.textContent = '';
        }

        if (displayShippingAddress) {
            displayShippingAddress.textContent = '';
        }

        if (displayShippingPostcode) {
            displayShippingPostcode.textContent = '';
        }

        if (displayShippingCity) {
            displayShippingCity.textContent = '';
        }

        jQuery( document.body ).trigger( 'update_checkout' );

        return;
    }

    checkboxWrap.style.display = 'none';
    shippingShowChosenVal.style.display = 'block';

    const data = select.value.split(',');

    if (!Array.isArray(data) || data.length !== 4) {
        address.value = '';
        postcode.value = '';
        city.value = '';

        console.error('The terminal value has less data that it should, check the commas!');
        return;
    }

    address.value = data[1].trim();
    postcode.value = data[2].trim();
    city.value = data[3].trim();
    name.value = billingName.value;
    surname.value = billingSurname.value;
    company.value = billingCompany.value;

    if (shippingShowChosenVal) {
        shippingShowChosenVal.textContent = select.value;
    }

    if (displayShippingTerminal) {
        displayShippingTerminal.textContent = data[0].trim();
    }

    if (displayShippingAddress) {
        displayShippingAddress.textContent = data[1].trim();
    }

    if (displayShippingPostcode) {
        displayShippingPostcode.textContent = data[2].trim();
    }

    if (displayShippingCity) {
        displayShippingCity.textContent = data[3].trim();
    }

    if (shippingFields) {
        shippingFields.forEach((shippingField) => {
            if (shippingField.value) {
                shippingField.setAttribute('readonly', 'readonly');
                shippingField.classList.add('--readonly');
            }
        });
    }

    jQuery( document.body ).trigger( 'update_checkout' );
}

/**
 * Init of the terminal selection.
 */
const maksimerTerminalInit = () => {
    const select = document.querySelector('#billing_terminal');

    if (!select) {
        return;
    }

    maksimerTerminalSelection( select );

    select.addEventListener('change', () => {
        maksimerTerminalSelection( select );
    });
}

maksimerTerminalInit();

/**
 * Toggle display of terminal picker based on local pickup 
 * shipping method is chosen or not.
 */
jQuery('body').on('updated_shipping_method', function() {
    const select = document.querySelector('#billing_terminal');

    if (!select) {
        return;
    }

    maksimerTerminalSelection( select );
});